﻿import {postRequest} from "../utils_modules/fetch";

export interface ISubscription {
	applicationId: string;
	pointOfSaleId: string;
	language: string;
	email: string;
	source: string;
	newsletter: boolean;
	personalMessage?: boolean;
}

export interface IUnSubscription {
	applicationId: string;
	pointOfSaleId: string;
	personId: string;
	newsletter: boolean;
	personalMessage?: boolean;
}

export function subscribeAsync(email: string, appId: string, posId: string, lang: string, source?: string) {
	const subscription: ISubscription = {
		applicationId: appId,
		pointOfSaleId: posId,
		language: lang,
		email,
		source,
		newsletter: true
	};

	return postRequest<ISubscription, void>("/api/v1/AccountService.svc/json/Subscribe", subscription, {headers: new Headers({'Content-type': 'application/json; charset=utf-8'})}).then(res => {
		// 
	}) as Promise<void>;
}

export function unSubscribeAsync(personId: string, appId: string, posId: string) {
	const unSubscription: IUnSubscription = {
		applicationId: appId,
		pointOfSaleId: posId,
		personId: personId,
		newsletter: true,
		personalMessage: true
	};

	return postRequest<IUnSubscription, void>("/api/v1/AccountService.svc/json/Unsubscribe", unSubscription, {headers: new Headers({'Content-type': 'application/json; charset=utf-8'})}).then(res => {
		// 
	}) as Promise<void>;
}

export function getPersonIdAsync(email: string, posId: string) {
	const personIdRequest = {
		email: email,
		pointOfSaleId: posId
	};
	return postRequest<{ email, pointOfSaleId }, void>("/api/v1/AccountService.svc/json/GetPersonForEmail", personIdRequest, {headers: new Headers({'Content-type': 'application/json; charset=utf-8'})}).then(res => {
		// 
	}) as Promise<void>;
}
